module.exports = __webpack_public_path__ + "static/roboto-v29-latin-300-80fe119e5efa3911b9d61b265f723b3d.woff2";